import { Right, RightService, TCreateRightRequest, TUpdateRightRequest } from '@talon/web/lib/api';
import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from './baseStore'; // for some dumb reason, these have to be imported individually
import { RootStore } from './rootStore'; // for some dumb reason, these have to be imported individually

export class RightStore extends BaseStore {
  isSaving = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      isSaving: observable,
    });
  }

  setIsSaving(isSaving: boolean) {
    runInAction(() => (this.isSaving = isSaving));
  }

  getRight = async (rightId: string, relations?: string) => {
    try {
      const { right } = await RightService.getRight(rightId, relations);
      return right;
    } catch (e) {
      this.handleError(e);
    }
  };

  getRightsByAdvertiserId = async (advertiserId: string) => {
    try {
      const { rights } = await RightService.listRights(advertiserId);
      return rights;
    } catch (e) {
      this.handleError(e);
    }
  };

  getRightsByCommercialId = async (commercialId: string) => {
    try {
      const { rights } = await RightService.listRights(undefined, commercialId);
      return rights;
    } catch (e) {
      this.handleError(e);
    }
  };

  listRights = async (options?: {
    advertiserId?: string;
    commercialId?: string;
    status?: string;
    rightType?: string;
    limit?: number;
    page?: number;
    orderAsJsonString?: string;
    relations?: string;
  }) => {
    try {
      const { rights } = await RightService.listRights(
        options?.advertiserId,
        options?.commercialId,
        options?.status,
        options?.rightType,
        options?.limit,
        options?.page,
        options?.orderAsJsonString,
        options?.relations
      );
      return rights;
    } catch (e) {
      this.handleError(e);
    }
  };

  createRight = async (rightData: TCreateRightRequest) => {
    try {
      this.setIsSaving(true);
      const { right } = await RightService.createRight(rightData);
      return right;
    } catch (e) {
      this.handleError(e);
    } finally {
      this.setIsSaving(false);
    }
  };

  updateRight = async (right: Partial<Right> & Pick<Right, 'id'>, documentId?: string) => {
    const updateRequest: TUpdateRightRequest = {
      ...right,
      advertiserId: right.advertiser?.id,
      commercialIds: right.commercials?.map((c) => c.id),
      documentId: documentId,
    };
    try {
      this.setIsSaving(true);
      const { right: updatedRight } = await RightService.updateRight(right.id, updateRequest);
      return updatedRight;
    } catch (e) {
      this.handleError(e);
    } finally {
      this.setIsSaving(false);
    }
  };

  deleteRight = async (rightId: string) => {
    try {
      this.setIsSaving(true);
      await RightService.deleteRight(rightId);
    } catch (e) {
      this.handleError(e);
    } finally {
      this.setIsSaving(false);
    }
  };
}
